import { saveAs } from 'file-saver'
import { getCookiesValue } from 'helpers/cookie'

export const downloadFile = async (fileName, fileLink) => {
  try {
    const token = getCookiesValue('ac_token')

    const response = await fetch(fileLink, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) {
      return false
    }

    const blob = await response.blob()
    saveAs(blob, fileName)

    return true
  } catch (e) {
    return false
  }
}
